// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2PgbD","header":"Messages_header__1zAjC"};